import Immutable from 'seamless-immutable';
import { ENTITLEMENT_BALANCES_TO_UPDATE, SET_SELECTED_ENTITLEMENT } from './actions/entitlement.balance.update.modal.actions';
export var INITIAL_STATE = Immutable({
  isLoading: false,
  data: {},
  selectedEntitlement: {}
});
export default function entitlementBalanceUpdateModalReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var _ref = arguments.length > 1 ? arguments[1] : undefined,
    _ref$payload = _ref.payload,
    payload = _ref$payload === void 0 ? {} : _ref$payload,
    type = _ref.type;
  switch (type) {
    case ENTITLEMENT_BALANCES_TO_UPDATE.BEGIN:
      return state.set('isLoading', true);
    case ENTITLEMENT_BALANCES_TO_UPDATE.SUCCESS:
      return state.set('isLoading', false).set('data', payload);
    case ENTITLEMENT_BALANCES_TO_UPDATE.FAILURE:
      return state.set('isLoading', false);
    case SET_SELECTED_ENTITLEMENT:
      return state.set('selectedEntitlement', payload);
    default:
      return state;
  }
}